module.exports = __webpack_public_path__ + "static/Fremont-1193de613d9e1afac6af63271eb9b4dc.jpg";